import Parsely from './parsely'

const parsely = new Parsely()
parsely.init()
